import { render, staticRenderFns } from "./CustomOrderItem.vue?vue&type=template&id=035cf7d4&scoped=true"
import script from "./CustomOrderItem.vue?vue&type=script&lang=js"
export * from "./CustomOrderItem.vue?vue&type=script&lang=js"
import style0 from "./CustomOrderItem.vue?vue&type=style&index=0&id=035cf7d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035cf7d4",
  null
  
)

export default component.exports